import { arCount } from "@/lib/ar-count";

/** Up to and including the first «.», «؟» or «!». */
export function firstSentence(text: string | null | undefined): string {
  const t = (text ?? "").trim();
  const m = t.match(/^[^.؟!]*[.؟!]/);
  return (m ? m[0] : t).trim();
}

export const minutesPhrase = (n: number) =>
  arCount(n, { one: "دقيقة وحدة", two: "دقيقتين", few: "دقايق", many: "دقيقة" });

export const articlesPhrase = (n: number) =>
  arCount(n, { one: "مقال واحد", two: "مقالين", few: "مقالات", many: "مقال" });

/** Reading pill text: «باقي 5 دقايق», or «مقروء» at the end. */
export function remainingLabel(readingMin: number | null | undefined, progress: number): string {
  const p = Math.min(1, Math.max(0, progress));
  if (p >= 0.995) return "مقروء";
  const left = Math.max(1, Math.ceil((readingMin ?? 0) * (1 - p)));
  return `باقي ${minutesPhrase(left)}`;
}
